export default __webpack_public_path__ + "static/media/DVI.1dad2d6e.svg";